import { render, staticRenderFns } from "./AddTxgl.vue?vue&type=template&id=72283ec2&scoped=true&"
import script from "./AddTxgl.vue?vue&type=script&lang=js&"
export * from "./AddTxgl.vue?vue&type=script&lang=js&"
import style0 from "./AddTxgl.vue?vue&type=style&index=0&id=72283ec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72283ec2",
  null
  
)

export default component.exports